module.exports = __webpack_public_path__ + "static/media/02.Tulasi Sanmana - Kogga Devanna Kamath.2f050ed5.jpg";